"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implemented by objects providing a specific source
 */
var Source = /** @class */ (function () {
    function Source() {
    }
    /**
     *
     * @param visitor - A SourceVisitor
     */
    Source.prototype.getDataFor = function (visitor) {
        if (!visitor.supportedSourcesSlugs().includes(this.slug)) {
            throw new Error("The '" + visitor.name + "' view does not support '" + this.name + "' as a source");
        }
        return visitor.getDataFrom(this);
    };
    return Source;
}());
exports.Source = Source;
//# sourceMappingURL=Source.js.map